import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Sortable from 'sortablejs';
import Cache from 'root/cache';
import Collection_Workflow from 'collection/workflow';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    className: 'workflow-edit-dialog',

    events: {
        'click .add'                : 'onAdd',
        'click .remove'             : 'onRemove',
        'keyup input.workflow-name' : 'onNameChange',
        'keyup input.colour'        : 'onColourChange',
        'submit form'               : 'onSubmit'
    },

    dom_handlers: {
        onAdd: function(e) {
            var temp_id = _.uniqueId();

            var new_container = $('<div>').html(this.getContainerHTML(false, false, false, temp_id)).children('.container');

            new_container.appendTo(this.$el.find('.container-wrapper'));
            new_container.find('input.workflow-name').focus();

            Form.setData(this.$el.find('form'), {
                ['workflow_colour_' + temp_id]: '#8090A0'
            });

            this.sortable();

            this.checkChange();
        },

        onRemove: function(e) {
            var container   = $(e.currentTarget).parents('.container:first');
            var workflow_id = parseInt(container.data('id'), 10);

            if (workflow_id === 0) {
                container.remove();
                return;
            }

            $(e.currentTarget).prop('disabled', true).addClass('loading');

            Cache.app.request({
                action:  'workflow/canDelete',
                context: this,
                data: {
                    id: workflow_id
                },
                success: function(response) {
                    if (response > 0) {
                        UI.error('Please delete the feedback in this status first.');
                    } else {
                        container.addClass('removed');
                        this.checkChange();
                    }
                },
                complete: function() {
                    $(e.currentTarget).prop('disabled', false).removeClass('loading');
                }
            });
        },

        onNameChange: function(e) {
            this.checkChange();
        },

        onColourChange: function(e) {
            this.checkChange();
        },

        onSubmit: function(e) {
            e.preventDefault();

            var workflow_data = [];

            this.$el.find('.container').each(function(index) {
                var workflow_id     = parseInt($(this).data('id'), 10);
                var workflow_sort   = parseInt(index, 10);
                var workflow_name   = $(this).find('input.workflow-name').val().trim();
                var workflow_colour = $(this).find('input.colour').val().trim();

                workflow_data.push({
                    id         : workflow_id,
                    name       : workflow_name,
                    sort       : workflow_sort,
                    colour     : workflow_colour,
                    is_deleted : $(this).hasClass('removed')
                });
            });

            var has_undeleted = false;
            _.each(workflow_data, function(data) {
                if (data.is_deleted === false) {
                    has_undeleted = true;
                }
            });

            if (has_undeleted === false) {
                UI.error('You need at least one workflow in this project');
                return;
            }

            this.$el.find('.submit').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action:  'workflow/edit',
                data: {
                    project_id: this.model.id,
                    workflow: workflow_data
                },
                complete: () => {
                    this.$el.find('.submit').prop('disabled', false).removeClass('loading');
                },
                success: (response) => {
                    response.forEach((data) => {
                        // update existing models
                        if (Cache.workflow.get(data.id)) {
                            Cache.workflow.get(data.id).set(data);
                        } else {
                            // add new models
                            Cache.workflow.add(data);
                        }
                    });

                    // remove deleted models
                    workflow_data.forEach((data) => {
                        if (data.is_deleted) {
                            Cache.workflow.remove(data.id);
                        }
                    });

                    // sort the collection and tell the feedback page to update
                    Cache.workflow.sort();

                    this.workflow = new Collection_Workflow(response).where({project_id: this.model.id});

                    UI.success('Status updated');

                    this.render();
                    this.trigger('Submit');
                }
            });
        }
    },

    initialize: function() {
        this.workflow = Cache.workflow.where({project_id: this.model.id});
    },

    isLoaded: function() {
        return this.workflow.length ? true : false;
    },

    load: function() {
        Cache.app.request({
            action: 'workflow/get',
            data: {
                project_id: this.model.id
            },
            success: (response) => {
                this.workflow = new Collection_Workflow(response).where({project_id: this.model.id});
                this.render();
            }
        });
    },

    checkChange: function() {
        this.$el.find('button.submit').prop('disabled', false);
    },

    sortable: function() {
        const el = this.$el.find('.dragable-container').get(0);

        if (!el) {
            return;
        }

        new Sortable(el, {
            ghostClass: 'drag-placeholder',
            handle: '.drag-handle',
            onSort: this.checkChange.bind(this),
        });
    },

    getContainerHTML: function(workflow_model, is_first, is_last, temp_id) {
        return '' +
        '<div class="container' + (is_first || is_last ? ' container-disabled' : '') + '" data-id="' + (workflow_model ? workflow_model.id : 0) + '">' +
            '<span class="drag-handle"></span>' +
            '<div class="content">' +
                '<input type="text" class="workflow-name compact" value="' + (workflow_model ? workflow_model.escape('name') : '') + '" placeholder="Status name" maxlength="50" required>' +
                (is_first || is_last ? '' :
                '<button type="button" class="small round square text remove"><i class="fa-solid fa-circle-minus"></i></button>') +
                '<div class="colour-edit">' +
                    '<input type="text" name="workflow_colour_' + (workflow_model ? workflow_model.id : temp_id) + '" class="colour compact" spellcheck="false" required>' +
                '</div>' +
            '</div>' +
        '</div>';
    },

    render: function() {
        var workflow_data = {};

        var content =
        '<form class="form-fluid">' +
            '<div class="project-settings-inner">' +
                (this.isLoaded() ?
                '<div class="field-label">Default status</div>' +
                this.getContainerHTML(this.workflow[0], true, false) +

                '<div class="field-label">Custom status</div>' +
                '<div class="container-wrapper dragable-container">' +
                    this.workflow.map((workflow_model, key) => {
                        workflow_data['workflow_colour_' + workflow_model.id] = workflow_model.get('colour');

                        if (key !== 0 && key !== this.workflow.length - 1) {
                            return this.getContainerHTML(workflow_model);
                        } else {
                            return '';
                        }
                    }).join('') +
                '</div>' +
                '<div class="workflow-add">' +
                    '<button type="button" class="add text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add status</button>' +
                '</div>' +

                '<div class="field-label">Resolved status</div>' +
                this.getContainerHTML(this.workflow[this.workflow.length - 1], false, true)

                :

                // loading state
                '<div class="loader-placeholder margin-bottom-8"></div>' +
                '<div class="loader-placeholder margin-bottom-8"></div>' +
                '<div class="loader-placeholder"></div>') +
            '</div>' +
            '<div class="project-settings-save">' +
                '<button class="primary submit medium" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        if (this.isLoaded()) {
            Form.setData(this.$el.find('form'), workflow_data);
            this.sortable();
        } else {
            this.load();
        }

        return this;
    }
});
